import { render, staticRenderFns } from "./contract-list.component.vue?vue&type=template&id=ebc4f22e"
import script from "./contract-list.component.vue?vue&type=script&lang=ts"
export * from "./contract-list.component.vue?vue&type=script&lang=ts"
import style0 from "./contract-list.component.vue?vue&type=style&index=0&id=ebc4f22e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports